import {Component, h, Fragment} from "preact";
import {t} from "../../_i18n";
import DropdownButton from "../../_common/components/dropdownButton";
import {isMobileAgent} from "../../_common/common";

const dropDownValues : {[key:string]: any} = {
    accepted: {name: 'accepted', translate: 'Pasar a ´En proceso´', desc: 'Si el candidato es preseleccionado.'},
    selected: {name: 'selected', translate: 'Pasar a ´Finalista´', desc: 'Si el candidato pasa a la fase final.'}
}

export const ButtonApplied = ({handleDiscard, handleClick, initialStatus}: any) => (
    <Fragment>
        <button className="btn btn-ghost descartar"
                onClick={()=> handleDiscard()}>
            <span className={'text-discard text-normal'}>{t('Descartar')}</span>
        </button>
        <DropdownButton className='sm-m-l no-m-l sm-no-m-top m-top font-medium'
                        initialStatus={initialStatus}
                        values={dropDownValues}
                        isMobile={isMobileAgent()}
                        onClick={(status: string) => handleClick(status)}/>
    </Fragment>
)

export const ButtonAcepted = ({handleDiscard, handleClick}: any) => (
    <Fragment>
        <button className="btn btn-ghost descartar"
                onClick={()=> handleDiscard()}>
            <span className={'text-discard text-normal'}>{t('Descartar')}</span>
        </button>
        <div className='dropdown-selector sm-m-l no-m-l sm-no-m-top m-top'>
            <div className='dropdown-button' onClick={()=> handleClick()}>
                <div className='dropdown-button__text dropdown-button__text-simple'>
                    Seleccionar
                </div>
            </div>
        </div>
    </Fragment>
)

export const ButtonSelected = ({handleDiscard}: any) => (
    <Fragment>
        <button className="btn btn-ghost descartar"
                onClick={()=> handleDiscard()}>
            <span className={'text-discard text-normal'}>{t('Descartar')}</span>
        </button>
    </Fragment>
)

export const ButtonDiscard = ({handleClick, initialStatus}: any) => (
    <Fragment>
        <DropdownButton className='sm-m-l no-m-l sm-no-m-top m-top font-medium'
                        initialStatus={initialStatus}
                        values={dropDownValues}
                        isMobile={isMobileAgent()}
                        onClick={(status: string) => handleClick(status)}/>
    </Fragment>
)
